<template>
	<TopicTemplate 
		:name="name" 
		:topicImage="topicImage" 
		:title="title"
		:appointment="appointment"
		:summary="summary"
		:content="content"
		:result="result"
		:selected="selected">
	</TopicTemplate>
</template>
<script>

import AppointmentView from '../../mixin/appointment-view'
import TopicTemplate from './template/TopicTemplate'

export default {
	name: 'appointment-vital',
	data() {
		return {
			name: 'vital_question',
			topicImage: 'vital.png',
			title: 'Vitals'
		}
	},
	mixins: [ AppointmentView ],
	mounted() {
	},
	components: {
		TopicTemplate
	}
}
</script>

<style lang="scss" scoped>
</style>